// Les actions pour notre reducer
const actionTypes = {
    SET_SUBJECT_FILE: 'SET_SUBJECT_FILE',
    SET_CORRECTION_FILE: 'SET_CORRECTION_FILE',
    SET_TITLE: 'SET_TITLE',
    SET_COMMENTS: 'SET_COMMENTS',
    NEXT_STEP: 'NEXT_STEP',
    PREV_STEP: 'PREV_STEP',
    SET_THEME: 'SET_THEME',
    SET_DESCRIPTORS: 'SET_DESCRIPTORS',
    SET_KNOWLEDGE: 'SET_KNOWLEDGE',
    SET_ATTENDUS: 'SET_ATTENDUS',
    SET_COMPETENCES: 'SET_COMPETENCES',
    SET_EVAL_DATE: 'SET_EVAL_DATE',
    POST_EVAL_DATE: 'POST_EVAL_DATE',
    SET_EVAL_QUESTIONS: "SET_EVAL_QUESTIONS",
    SET_DURATION:"SET_DURATION",
    SET_TYPE: "SET_TYPE",
    // ... autres types d'actions si nécessaire
  };

export const addEvalReducer = (state, action) => {
    switch (action.type) {
      case actionTypes.SET_SUBJECT_FILE:
        return { ...state, subjectFile: action.payload };

      case actionTypes.SET_CORRECTION_FILE:
        return { ...state, correctionFile: action.payload };

      // Ajoutez d'autres cas pour chaque action...
      case actionTypes.SET_TITLE:
        return {...state , title: action.payload};

      case actionTypes.SET_DURATION:
        return {...state, duration: action.payload};
        
      case actionTypes.SET_COMMENTS:
        return {...state, comments: action.payload};

      case actionTypes.NEXT_STEP:
        return {...state, step: state.step + 1};

      case actionTypes.PREV_STEP:
          // On décrémente l'étape ; les compétences saisies sont CONSERVÉES
          // (elles ne sont purgées qu'au décochage d'un savoir-faire/attendu).
          return { ...state, step: state.step - 1 };

      case actionTypes.SET_THEME:
        return {...state, selectedTheme: action.payload}

      case actionTypes.SET_DESCRIPTORS:
        return {...state, selectedDescripteur: action.payload}

      case actionTypes.SET_KNOWLEDGE: {
        const savoirExists = state.selectedSavoirs.some(s=> s === action.payload)
        return {...state,
            selectedSavoirs: savoirExists ? state.selectedSavoirs.filter(s=> s !== action.payload)
            : [...state.selectedSavoirs, action.payload],
            // En décochant un savoir-faire, on retire ses compétences (pas d'orphelins).
            selectedComps: savoirExists
              ? state.selectedComps.filter(e => !(e.type === 'savoir' && e.savoir.id === action.payload.id))
              : state.selectedComps,
            };
      }

      case actionTypes.SET_ATTENDUS: {
        const attendusExists = state.selectedAttendus.some(s=> s === action.payload)
        return {...state,
          selectedAttendus: attendusExists ? state.selectedAttendus.filter(s=> s !== action.payload)
            : [...state.selectedAttendus, action.payload],
            // En décochant un attendu, on retire ses compétences (pas d'orphelins).
            selectedComps: attendusExists
              ? state.selectedComps.filter(e => !(e.type === 'attendu' && e.savoir.id === action.payload.id))
              : state.selectedComps,
            };
      }

  case actionTypes.SET_COMPETENCES: {
  const { savoir, comp, type } = action.payload;
  // On cherche un objet qui a à la fois le même savoir *et* le même type
  const idx = state.selectedComps.findIndex(
    e => e.savoir.id === savoir.id && e.type === type
  );
  const newSelectedComps = [...state.selectedComps];

  if (idx !== -1) {
    const entry = { ...newSelectedComps[idx] };
    const compsSet = new Set(entry.competences);

    if (compsSet.has(comp)) compsSet.delete(comp);
    else compsSet.add(comp);

    const updated = Array.from(compsSet);
    if (updated.length) {
      // on met à jour la même entrée, en gardant savoir + type
      newSelectedComps[idx] = { ...entry, competences: updated };
    } else {
      // plus de comp → on supprime l’entrée entière
      newSelectedComps.splice(idx, 1);
    }
  } else {
    // pas trouvé → on ajoute un nouvel objet { savoir, competences:[comp], type }
    newSelectedComps.push({ savoir, competences: [comp], type });
  }

  return { ...state, selectedComps: newSelectedComps };
}
    

        case actionTypes.SET_EVAL_DATE:
        
            return {...state, evalDate: action.payload};

        case actionTypes.POST_EVAL_DATE:
            return {...state, postEvalDate: action.payload};

        
        case actionTypes.SET_EVAL_QUESTIONS:
          return {...state, questions: action.payload};
        
        case actionTypes.SET_TYPE:
          return {...state, taskType: action.payload};
            
      default:
        throw new Error(action.type);
    }
  }